import { Link } from '@wbk/config';
import { ContentfulMedia } from '@wbk/contentful';
import { Button } from '@wbk/ui';
import { type WebSection } from '@wbk/contentful/api';
import useLocalization from '@/context/localization/useLocalization';

type Props = {
  section: WebSection;
};
const LaylatAlomr = ({ section }: Props) => {
  const { locale } = useLocalization();

  const btnLabel = section.webLinksCollection?.items?.[0]?.label;
  return (
    <>
      <div className='container !mb-[5rem] max-h-[500px]'>
        <div className='container'>
          <div className='relative h-[500px] w-full overflow-hidden rounded-3xl bg-white/20'>
            <ContentfulMedia
              media={section.sectionBackground!}
              className='h-full w-full object-cover'
            />

            <div className='absolute inset-x-0 bottom-6 flex items-center justify-center px-6'>
              <Button
                as={Link}
                href={`/${locale}/laylat-alomr`}
                className='md:text-body-M rounded-full py-2 font-medium lg:px-6'
              >
                <span className='w-[80%] sm:w-full'>{btnLabel}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LaylatAlomr;
